import React, { useState } from 'react'
import ReactModal from 'react-modal'
import Checkbox from 'src/components/Checkbox'
import { FC_FLOW_PRE_URL, FC_FLOW_POS_URL } from '../../../../../services/api'
import {
	CloseButton,
	Container,
	Line,
	Link,
	ModalHeader,
	Terms,
	TextBlock,
} from './styles'
import { Button } from '../styles'
import { eventTrack } from 'src/components/GoogleTagManager'

function Footer({
  buttonColor,
  terms,
  modalOpen,
  disabled,
  cupons,
  textColor,
}) {
  let queroPre = "Quero Pré";
  let queroPos = "Quero Pós";
  const [checked, setChecked] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [firstButtonText, setFirstButtonText] = useState(queroPos);
  const [secondButtonText, setSecondButtonText] = useState(queroPre);
  return (
    <>
      <Container blur={modalOpen}>
        <Terms color={checked}>
          <Checkbox
            id="check-term"
            disabled={modalOpen}
            onChange={() => {
              setChecked(!checked);
              eventTrack(
                'veloe:institucional',
                'interacao:checkbox',
                'check-term:' + String(!checked)
              );
            }}
            className="termoAceite"
          />
          <label htmlFor="check-term">
            Estou ciente que, ao prosseguir, aceito o{" "}
            <b
              onClick={() => !disabled && setOpenModal(true)}
              disabled={modalOpen}
              style={{
                pointerEvents: disabled && "none",
              }}
            >
              regulamento
            </b>{" "}
            da campanha.
          </label>
        </Terms>
        <div className="botoesCupons">
          <Link
            disabled={!checked}
            href={
              disabled ? "" : `${FC_FLOW_POS_URL}?origem=lp&codigo=${cupons[0]}`
            }
          >
              <Button
                disabled={!checked}
                color={textColor}
                onMouseLeave={() => setFirstButtonText(queroPos)}
              >
               {firstButtonText}
              </Button>
          </Link>
          <Link
            disabled={!checked}
            href={
              disabled ? "" : `${FC_FLOW_PRE_URL}?origem=lp&codigo=${cupons[1]}`
            }
          >
              <Button
                disabled={!checked}
                color={textColor}
                onMouseLeave={() => setSecondButtonText(queroPre)}
              >
                {secondButtonText}
              </Button>
          </Link>
        </div>
      </Container>
      <ReactModal isOpen={openModal} onRequestClose={() => setOpenModal(false)}>
        <ModalHeader>
          <CloseButton
            src="/unidasseminovos/assets/icon-close.png"
            onClick={() => setOpenModal(false)}
          />
        </ModalHeader>
        <div>
          {terms.content &&
            terms.content?.map((term) => (
              <Line>
                {term.content.map(({ value, marks }) => {
                  const className = !!marks
                    ? marks.map((mark) => mark.type).join(" ")
                    : "";
                  return <TextBlock className={className}>{value}</TextBlock>;
                })}
              </Line>
            ))}
        </div>
      </ReactModal>
    </>
  );
}

export default Footer;
